import Button from './button.view';

export default class TreeDiagram {

	constructor(exercise, renderer, $timeout, audioService) {
    this.exercise = exercise;
    this.buttons = [];
    this.renderer = renderer;
    this.$timeout = $timeout;
    this.audioService = audioService;
    this.renderer.onDropItem = this._onDropAnswer.bind(this);
    this.renderer.onOverlapItem = this._onOverlapAnswer.bind(this);
	}
  
  /**
   * @returns {Promise}
   */
  autocomplete() {
    this._fillCorrectAnswers();
    return this._autocompleteAnswersAsync(); 
  }
  
  /**
   * @returns {Boolean}
   */
	complete() {
    return this._checkFinalAnswer();
  }
  
  /**
   * @returns {Promise}
   */
	restart() {
    this.renderer.empty();
    return this._restartAnswersAsync();
  }

  registerButton(button) {
    if (button instanceof Button) {
      this.buttons.push(button);
    }
  }

  _findButtonById(id) {
    return this.buttons.find((button) => button.id === id);
  }

  _onDropAnswer() {
    this.audioService.play('tab');
  }

  _onOverlapAnswer(data) {
    this.audioService.play('tab');
    
    if (data.previous) {
      let previousButton = this._findButtonById(data.previous);

      if (previousButton) {
        previousButton.revert();  
      }
    }
  }

  _checkFinalAnswer() {
    const correctAnswers = this.exercise.answer;
    const userAnswers = this.renderer.flatten();
    return correctAnswers.every((correctAnswer, i) => correctAnswer === userAnswers[i]);
  }

  _fillCorrectAnswers() {
    this.exercise.answer.forEach((correctAnswer, i) => {
      this.renderer.setModelAt(i, correctAnswer);
    });
  }

  _restartAnswersAsync() {
    let asyncList = this.buttons.map((button, i) => {
      return this.$timeout(function() {
        button.revert();
      }, 1000 * i);
    });

    return Promise.all(asyncList);
  }

  _autocompleteAnswersAsync() {
    let asyncList = this.buttons.map((button, i) => {
      let leaf = this.renderer.getByModel(button.id);
      return this.$timeout(function() {
        button.moveToElement(leaf.element);
      }, 1000 * i);
    });

    return Promise.all(asyncList);
  }

}


// WEBPACK FOOTER //
// ./client/app/components/tree-diagram/tree-diagram.view.js